<template>
  <div class="input-form-value">
    <label class="head">
      <i v-if="field.valid" class="fas fa-check-circle ok"></i>
      <i v-else class="fas fa-exclamation-circle warn"></i>
      <span>{{ field.label }}</span>
    </label>

    <!-- INPUTS -->
    <b-form-input v-if="field.type == QUESTION_TYPES.TEXT" type="text" :maxlength="field.questionRef.length && field.questionRef.length.max || 250" v-model.trim="field.value" :id="'input-update-' + index" class="shadow-none" placeholder="Texto"></b-form-input>
    <b-form-input v-if="field.type == QUESTION_TYPES.PHONE" type="tel" maxlength="15" v-model.trim="field.value" :id="'input-update-' + index" class="shadow-none" placeholder="Teléfono (5512623520)"></b-form-input>
    <b-form-input v-if="field.type == QUESTION_TYPES.EMAIL" type="email" maxlength="100" v-model="field.value" :id="'input-update-' + index" class="shadow-none" placeholder="Correo electrónico"></b-form-input>
    <b-form-input v-if="field.type == QUESTION_TYPES.INTEGER" type="number" v-model="field.value" :id="'input-update-' + index" class="shadow-none" placeholder="Número"></b-form-input>
    <b-form-input v-if="field.type == QUESTION_TYPES.DECIMAL" type="number" v-model="field.value" :id="'input-update-' + index" class="shadow-none" placeholder="Número"></b-form-input>
    <b-form-input v-if="field.type == QUESTION_TYPES.CURRENCY" type="number" v-model="field.value" :id="'input-update-' + index" class="shadow-none" placeholder="Cantidad"></b-form-input>

    <!-- DATES -->
    <DateSelector v-if="field.type == 'date'" format="DD/MM/YYYY" :editable="false" :clearable="false" v-model="field.value"/>
    <DateSelector v-if="field.type == 'dateTime'" type="datetime" format="DD/MM/YYYY - HH:mm:ss [hrs.]" :editable="false" :clearable="false" v-model="field.value"/>
    <DateSelector v-if="field.type == 'time'" type="time" format="HH:mm:ss [hrs.]" :editable="false" :clearable="false" v-model="field.value"/>

    <!-- SELECTION SIMPLE -->
    <b-form-select v-if="field.type == QUESTION_TYPES.SELECT && field.questionRef.display.type === 'SIMPLE'"  v-model="field.value" :id="'input-update-' + index" class="shadow-sm">
      <template slot="first">
        <option :value="''">Selecciona una opción</option>
      </template>
      <option v-for="(value, name, index) in field.questionRef.display.options" :key="index" :value="value">{{ name }}</option>
    </b-form-select>

    <!-- SELECTION MULTIPLE -->
    <b-form-select v-if="field.type == QUESTION_TYPES.SELECT && field.questionRef.display.type === 'MULTIPLE'" multiple  v-model="field.value" :id="'input-update-' + index" class="shadow-sm">
      <option v-for="(value, name, index) in field.questionRef.display.options" :key="index" :value="value">{{ name }}</option>
    </b-form-select>

    <!-- SELECTION PRIORITY -->
    <div class="priority-field" v-if="field.type == QUESTION_TYPES.SELECT && field.questionRef.display.type === 'PRIORITY'">
      <b-form-select v-model="field.value" :id="'input-update-' + index" class="shadow-sm">
        <option value="">Seleccione una opción</option>
        <option v-for="(value, name, index) in field.questionRef.display.options" :key="index" :value="value" :style="{ background: name }">{{ value }}</option>
      </b-form-select>
      <div class="selected-color" v-if="field.value" :style="{ background: field.value }"></div>
    </div>

    <div v-if="!field.valid" class="error">{{ field.error }}</div>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import DateSelector from '@/components/generic/DateSelector.vue'
import { TemplateQuestionsTypes } from '@/types/Fillgrid'

@Component({
  components: {
    DateSelector
  }
})
export default class InputFormValue extends Vue {
  @Prop()
  field: any

  @Prop()
  index: number

  QUESTION_TYPES = TemplateQuestionsTypes

  feedback = ''

  regex = {
    email: /^[_A-Za-z0-9-]+(\.[_A-Za-z0-9-]+)*@[A-Za-z0-9]+(\.[A-Za-z0-9]+)*(\.[A-Za-z]{2,})$/,
    phone: /^[0-9]{7,15}$/,
    integer: /^-?[0-9]+$/,
    decimal: /^-?[0-9]+(\.[0-9]+)?$/
  }

  location = {
    lat: '',
    lng: '',
    alt: ''
  }

  created () {
    switch (this.field.type) {
      case TemplateQuestionsTypes.TEXT:
        this.field.error = 'Ingresa el texto'
        break
      case TemplateQuestionsTypes.EMAIL:
        this.field.error = 'Ingresa un correo válido (correo@dominio.com)'
        break
      case TemplateQuestionsTypes.PHONE:
        this.field.error = 'Ingresa un teléfono válido'
        break
      case TemplateQuestionsTypes.INTEGER:
        this.field.error = 'Ingresa un número entero válido'
        break
      case TemplateQuestionsTypes.DECIMAL:
        this.field.error = 'Ingresa un número decimal válido'
        break
      case TemplateQuestionsTypes.LOCATION:
        this.field.error = 'Ingresa una georeferencia válida'
        break
      default:
        this.field.error = 'Ingrese un valor'
    }
  }

  setLocation (value: string, part: string) {
    switch (part) {
      case 'lat':
        this.location.lat = value
        break
      case 'lng':
        this.location.lng = value
        break
      case 'alt':
        this.location.alt = value
    }
    this.field.value = `${this.location.lat},${this.location.lng},${this.location.alt}`
  }

  @Watch('field.value')
  watchValue (val: any) {
    this.isValidValue()
  }

  isValidValue () {
    if (!this.field.value) {
      this.field.valid = false
      return
    }

    switch (this.field.type) {
      case TemplateQuestionsTypes.TEXT:
        this.field.valid = this.field.value.length > 0
        break
      case TemplateQuestionsTypes.SELECT:
        this.field.valid = this.field.value.length > 0
        break
      case TemplateQuestionsTypes.PHONE:
        this.field.valid = this.regex.phone.test(this.field.value)
        break
      case TemplateQuestionsTypes.EMAIL:
        this.field.valid = this.regex.email.test(this.field.value)
        break
      case TemplateQuestionsTypes.INTEGER:
        this.field.valid = this.regex.integer.test(this.field.value)
        break
      case TemplateQuestionsTypes.DECIMAL:
        this.field.valid = this.regex.decimal.test(this.field.value)
        break
      case TemplateQuestionsTypes.LOCATION:
        const parts = this.field.value.split(',')
        this.field.valid = this.regex.decimal.test(parts[0]) &&
                           this.regex.decimal.test(parts[1]) &&
                           this.regex.decimal.test(parts[2])
        break
      default:
        this.field.valid = true
    }
  }
}
</script>

<style lang="scss">
.input-form-value {
  max-width: 400px;
  label.head {
    padding: 0 2px;
    display: block;
    i {
      margin-right: 7px;
      font-size: 1.1rem;
      &.ok {
        color: var(--success);
      }
      &.warn {
        color: var(--warning);
      }
    }
  }

  input, select {
    border: 0;
    box-shadow: none;
    border: 2px solid #888;
    border-radius: 0;
    border-radius: 4px;
    height: 45px;
    font-size: 1rem;
    &:focus {
      border: 2px solid var(--primary-color);
    }
  }

  .mx-datepicker {
    width: 100% !important;
  }

  .priority-field {
    display: flex;
    .selected-color {
      height: 44px;
      width: 12px;
      margin-left: 3px;
      border-top-right-radius: 4px;
      border-bottom-right-radius: 4px
    }
  }

  .error {
    padding: 5px;
    font-size: 0.85rem;
    color: #929292;
  }
}
</style>
